module.exports = __webpack_public_path__ + "img/zh_xdyl.642e7243.svg";